import React, { useContext } from "react";
import { appContext } from "../AarmaContext";
import { formatAddress } from "./Formate";
import CopyBtn from "./CopyBtn";
import { Link } from "react-router-dom";

function Header() {
  const { connectedAddress, isConnected, account, connectWallet, disconnect, switchNetwork } =
    useContext(appContext);

  const handleConnectWallet = (e) => {
    connectWallet(e.target.value);
    console.log(connectWallet(e.target.value));
    switchNetwork(80002);
  };

  const handleDisconnectWallet = () => {
    disconnect();
  };

  return (
    <header className="header-section header-menu w-100 pt-1 pt-lg-0 pb-3 pb-lg-0">
      <div className="navbar_mainhead header-fixed w-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 ">
              <nav className="navbar navbar-expand-lg position-relative py-md-3 py-lg-6 work ready d-flex justify-content-between">
                <Link to="/">
                  <img src="assets/images/aarma_logo.png" alt="" />
                </Link>
                <div className="navbar-collapse justify-content-end" id="navbar-content">
                  <ul className="navbar-nav d-flex align-items-lg-center gap-5 gap-lg-1 gap-xl-4 gap-xxl-7 py-2 py-lg-0 ms-2 ms-xl-10 ms-xxl-20 ps-0 ps-xxl-10 align-self-center">
                    <li className="dropdown show-dropdown">
                      {account ? (
                        <>
                          {/* <button type="button" aria-label="Navbar Dropdown Button" className="cmn-btn px-3 px-sm-5 px-md-6 py-2 py-sm-3 d-flex align-items-center gap-1 dropdown-toggle dropdown-nav d-flex align-items-center fs-ten"> {formatAddress(account)}&nbsp;
                          <CopyBtn text={account} />
                          <i className="ti ti-chevron-down" />
                        </button> */}
                          <button type="button" aria-label="Navbar Dropdown Button" className="cmn-btn px-3 px-sm-5 px-md-6 py-2 py-sm-3 d-flex align-items-center gap-1 dropdown-toggle dropdown-nav d-flex align-items-center fs-ten">
                            <i className="fa fa-regular fa-user text-white"></i>
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <span>{formatAddress(account)}&nbsp;
                                <CopyBtn text={account} /></span>
                            </li>
                            <li><Link className="dropdown-item fs-ten" to="/dashboard">Dashboard</Link></li>
                            <li><Link className="dropdown-item fs-ten" to="/referralreward">Referral Reward</Link></li>
                            <li><Link className="dropdown-item fs-ten" to="/claim">Claim</Link></li>
                            <li>
                              <Link
                                className="py-2 ts-3 m-2"
                                to="/"
                                onClick={handleDisconnectWallet}
                              >
                                Logout
                                {/* <i className="fa fa-sign-out fa-user"></i> */}
                              </Link>
                            </li>
                          </ul>
                        </>
                      ) : (
                        <button
                          type="button"
                          className="cmn-btn px-3 px-sm-5 px-md-6 py-3 py-sm-2 d-flex align-items-center gap-1 text-white"
                          onClick={handleConnectWallet}
                        >
                          <span className="p7- fw-semibold d-none d-sm-block">
                            Connect
                          </span>
                          Wallet
                        </button>
                      )}
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
